<!-- 用于展示改变后的值和改变前的值 -->

<template>
  <span>
    <span>{{ originalVal }}</span>
    <span>
      <span v-if="!isEmpty(originalVal) && item.change">---></span>
      <span style="margin-left: 10px;" class="color-red">
        {{ targetVal }}
      </span>
    </span>
  </span>
</template>

<script>
import { isEmpty } from '@/utils/common'

export default {
  methods: { isEmpty },
  props: {
    item: {
      default: () => ({})
    },
    // value映射 可调取convert填入
    mapper: {}
  },
  computed: {
    // 原始值
    originalVal () {
      if (this.item) {
        if (this.mapper && !isEmpty(this.item.current)) {
          // 提供了映射
          return (
            this.mapper[this.item.current] &&
            this.mapper[this.item.current].title
          )
        }

        // 未提供映射的情况
        return this.item.current
      } else {
        return ''
      }
    },
    targetVal () {
      if (this.mapper && !isEmpty(this.item.modify)) {
        return (
          this.mapper[this.item.modify] && this.mapper[this.item.modify].title
        )
      }
      return this.item.modify
    }
  }
}
</script>
